var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesigners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5035_34344)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.243652,
    y: 0.25,
    width: 62,
    height: 62,
    rx: 31,
    fill: "url(#paint0_linear_5035_34344)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.743652,
    y: 0.75,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.5447 23.1388C27.5447 21.895 28.4392 20.8867 29.5417 20.8867H32.2044C33.3069 20.8867 34.2014 21.895 34.2014 23.1388V26.1416C34.2014 27.385 33.3069 28.3937 32.2044 28.3937H29.5417C28.4392 28.3937 27.5447 27.385 27.5447 26.1416V23.1388ZM31.8715 25.7663V23.5142H29.8745V25.7663H31.8715ZM23.5508 34.3993C24.6533 34.3993 25.5477 35.4081 25.5477 36.6514V39.6542C25.5477 40.8975 24.6533 41.9063 23.5508 41.9063H20.8881C19.7852 41.9063 18.8911 40.8975 18.8911 39.6542V36.6514C18.8911 35.4081 19.7852 34.3993 20.8881 34.3993H23.5508ZM21.2209 37.0267V39.2788H23.2179V37.0267H21.2209ZM40.858 34.3993C41.9605 34.3993 42.855 35.4081 42.855 36.6514V39.6542C42.855 40.8975 41.9605 41.9063 40.858 41.9063H38.1953C37.0928 41.9063 36.1983 40.8975 36.1983 39.6542V36.6514C36.1983 35.4081 37.0928 34.3993 38.1953 34.3993H40.858ZM38.5282 37.0267V39.2788H40.5252V37.0267H38.5282Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5035_34344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5452 26.1409C27.5452 26.5679 27.6701 27.0418 27.8864 27.403C25.4318 28.6088 23.6594 31.255 23.414 34.3986H21.0771C21.2863 30.8375 22.9522 27.8112 25.4026 25.9532H22.6193C22.1867 26.9526 21.2755 27.6423 20.223 27.6423C18.7523 27.6423 17.5603 26.2957 17.5603 24.6395C17.5603 22.9809 18.7523 21.6367 20.223 21.6367C21.2755 21.6367 22.1867 22.326 22.6193 23.3258H27.5452V26.1409ZM34.2019 26.1409V23.3258H39.1278C39.5605 22.326 40.4716 21.6367 41.5242 21.6367C42.9928 21.6367 44.1868 22.9809 44.1868 24.6395C44.1868 26.2957 42.9928 27.6423 41.5242 27.6423C40.4716 27.6423 39.5605 26.9526 39.1278 25.9532H36.3445C38.7949 27.8112 40.4591 30.8375 40.6713 34.3986H38.3331C38.0877 31.255 36.3153 28.6088 33.8607 27.403C34.0396 27.0418 34.2019 26.5679 34.2019 26.1409Z",
    fill: "url(#paint1_linear_5035_34344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0732 34.0236H21.4812C21.7801 30.7404 23.3609 27.9719 25.6292 26.2521L26.5179 25.5782H25.4026H22.6193H22.3731L22.2752 25.8042C21.8915 26.6904 21.1015 27.2673 20.223 27.2673C19.0006 27.2673 17.9353 26.1325 17.9353 24.6395C17.9353 23.1444 19.0005 22.0117 20.223 22.0117C21.1016 22.0117 21.8915 22.5882 22.2752 23.4747L22.373 23.7008H22.6193H27.1702V26.1409C27.1702 26.5026 27.2469 26.8915 27.3885 27.2403C25.0691 28.5279 23.4108 31.0515 23.0732 34.0236ZM34.3454 27.233C34.4752 26.9009 34.5769 26.5141 34.5769 26.1409V23.7008H39.1278H39.3741L39.4719 23.4747C39.8556 22.5882 40.6455 22.0117 41.5242 22.0117C42.7447 22.0117 43.8118 23.1446 43.8118 24.6395C43.8118 26.1323 42.7446 27.2673 41.5242 27.2673C40.6456 27.2673 39.8556 26.6904 39.4719 25.8042L39.3741 25.5782H39.1278H36.3445H35.2292L36.1179 26.2521C38.3861 27.9718 39.9654 30.7402 40.2669 34.0236H38.6739C38.3357 31.0459 36.6717 28.5184 34.3454 27.233Z",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5035_34344",
    x: -4.75635,
    y: -4.75,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5035_34344",
    x: -4.4397,
    y: -0.363281,
    width: 70.6265,
    height: 56.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5035_34344",
    x1: -2.33968,
    y1: 64.3167,
    x2: 34.0245,
    y2: -3.82316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107494,
    stopColor: "#1671E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910617,
    stopColor: "#08E4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5035_34344",
    x1: 19.4743,
    y1: 22.7363,
    x2: 40.2961,
    y2: 40.0059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigners);
export default __webpack_public_path__ + "static/media/designers.269dcc109eec4e6751b5abe780d0da50.svg";
export { ForwardRef as ReactComponent };